module.exports = __webpack_public_path__ + "officialStatic/img/p4.a08e9cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/p4.png
// module id = 5Fv3
// module chunks = 0